import { Label } from '@progress/kendo-react-labels'
import { Input, InputChangeEvent } from '@progress/kendo-react-inputs'
import { StackLayout } from '@progress/kendo-react-layout'
import Constants from '../../../data/Constants.json'
import {
  DropDownList,
  DropDownListChangeEvent,
  MultiSelect,
  MultiSelectChangeEvent
} from '@progress/kendo-react-dropdowns'
import {
  BranchSelect,
  ExpenseSelect,
  FiscalMonthDropDownList
} from '../../../components/parts'

import { FC } from 'react'
import { StatusCheckActions, useAppDispatch, useAppSelector } from '../../../stores'

export const StatusCheckCondition: FC<{}> = () => {
  const userProp = useAppSelector((state) => state.common.userProp)
  const statusCheckConditionInfo = useAppSelector(
    (state) => state.statuscheck.statusCheckSearch
  )
  const dispatch = useAppDispatch()

  // 検索条件の活性状態
  const editableStatus = userProp?.authority === 5

  const initialData = useAppSelector((x) => x.common.initialData)
  const answerSituation = initialData.codeNames('KA03')
  const sortOrder = initialData.codeNames('SO01')

  /**
   * 回答月の取得
   * @param month 回答月
   */
  const handleSimulationM = (month: number) => {
    dispatch(
      StatusCheckActions.setStatusCheckSearch({
        ...statusCheckConditionInfo,
        simulationM: month.toString()
      })
    )
  }
  /**
   * 回答年の取得
   * @param year 回答年
   */
  const handleSimulationY = (year: number) => {
    dispatch(
      StatusCheckActions.setStatusCheckSearch({
        ...statusCheckConditionInfo,
        simulationY: year.toString()
      })
    )
  }
  /**
   * 支店の取得
   * @param value 支店
   */
  const handleBranchCdList = (valueList: string[]) => {
    dispatch(
      StatusCheckActions.setStatusCheckSearch({
        ...statusCheckConditionInfo,
        branchCdList: valueList
      })
    )
  }

  /**
   * 業者名の取得
   * @param event イベント
   */
  const hangleSupplierNm = (event: InputChangeEvent) => {
    dispatch(
      StatusCheckActions.setStatusCheckSearch({
        ...statusCheckConditionInfo,
        supplierNm: event.value
      })
    )
  }
  /** 回答状況の取得 */
  const createValueMulti = (codeValue?: string[]) => {
    const _value: any[] = []
    codeValue?.forEach((item) => {
      answerSituation.forEach((codeName) => {
        if (item === codeName.CODE) {
          _value.push(codeName)
        }
      })
    })
    return _value.length === 0 ? undefined : _value
  }

  const handleOnChangeMulti = (event: MultiSelectChangeEvent) => {
    const _value: string[] = []
    event.value.forEach((item: { CODE: string, NAME: string }) => {
      answerSituation.forEach((codeName) => {
        if (item.CODE === codeName.CODE) {
          _value.push(codeName.CODE)
        }
      })
    })
    dispatch(
      StatusCheckActions.setStatusCheckSearch({
        ...statusCheckConditionInfo,
        replyStsCdList: _value
      })
    )
  }

  /** ソート順の取得 */

  const createValue = (codeValue?: string) => {
    if (codeValue === undefined) {
      return null
    }
    const _value = sortOrder.find((codeName) => codeName.CODE === codeValue)
    return _value === undefined ? null : _value
  }

  const handleOnChange = (event: DropDownListChangeEvent) => {
    dispatch(
      StatusCheckActions.setStatusCheckSearch({
        ...statusCheckConditionInfo,
        sortOrder: event.value.CODE
      })
    )
  }

  return (
    <>
      <h3>検索条件</h3>

      <StackLayout gap={5} orientation="vertical">
        <Label>回答年月度</Label>
        <StackLayout gap={5} orientation="horizontal">
          <FiscalMonthDropDownList
            startYear={Number(Constants.systemStartYear)}
            fmddlValue={
              statusCheckConditionInfo.simulationM !== ''
                ? Number(statusCheckConditionInfo.simulationM)
                : undefined
            }
            fyddlValue={
              statusCheckConditionInfo.simulationY !== ''
                ? Number(statusCheckConditionInfo.simulationY)
                : undefined
            }
            onMonthChange={handleSimulationM}
            onYearChange={handleSimulationY}
          />
        </StackLayout>

        <Label>支店</Label>
        <BranchSelect
          multiple
          onChange={handleBranchCdList}
          value={statusCheckConditionInfo.branchCdList}
          disabled={editableStatus}
          autoClose={false}
        />

        <Label>費目</Label>
        <ExpenseSelect
          disabled={editableStatus}
          value={[statusCheckConditionInfo.expenseCd]}
          onChange={(valueList: string[]) => {
            dispatch(
              StatusCheckActions.setStatusCheckSearch({
                ...statusCheckConditionInfo,
                expenseCd: valueList[0]
              })
            )
          }}
          autoClose={false}
        />

        <Label>業者名</Label>
        <Input
          disabled={editableStatus}
          onChange={hangleSupplierNm}
          value={statusCheckConditionInfo.supplierNm}
        />

        <Label>回答状況</Label>
        <MultiSelect
          dataItemKey="CODE"
          textField="NAME"
          data={answerSituation}
          value={
            statusCheckConditionInfo.replyStsCdList?.length === 0
              ? []
              : createValueMulti(statusCheckConditionInfo.replyStsCdList)
          }
          disabled={editableStatus}
          onChange={handleOnChangeMulti}
        />
        <Label>ソート順</Label>
        <DropDownList
          disabled={editableStatus}
          data={sortOrder}
          dataItemKey="CODE"
          textField="NAME"
          value={createValue(statusCheckConditionInfo.sortOrder)}
          onChange={handleOnChange}
        />
      </StackLayout>
    </>
  )
}
